export default __webpack_public_path__ + "static/media/blog2.1f56b475.png";